import { PRODUCTS, BEST_SELLERS } from "./products";

export { PRODUCTS, BEST_SELLERS };

// ─── Site Configuration (numara, linkler, slogan buradan) ───────────────────
export const SITE = {
  name: "Atılmaz Saat",
  slogan: "Zamana Değer Katar",
  whatsappNumber: "905354507114",
  instagram: "atilmazsaat",
  shopifyUrl: "https://www.atilmazsaat.com",
  phone: "+90 535 450 71 14",
  email: "atilmazbalikesir@atilmazsaat.com",
  address: "Gaziosmanpaşa Mah. 381. Sok. No:10, Burda AVM Zemin Kat, No:3/149, Altıeylül / Balıkesir",
};

export const WA_DEFAULT_MSG =
  "Merhaba, Atılmaz Saat ürünleri hakkında bilgi almak istiyorum.";

export const waLink = (message = WA_DEFAULT_MSG) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const fmtPrice = (n) => `${n.toLocaleString("tr-TR")} ₺`;

// Hikâyemiz fotoğrafları — gerçek mağaza/tarihî fotoğrafları public/hikaye/ klasörüne yükleyip
// buraya bölüm numarasıyla ekleyin. Boşken sayfada hiçbir görsel alanı görünmez.
// Örnek: "01": { src: "/hikaye/01-otel-basri.jpg", alt: "Otel Basri görüşmesi, 2006", caption: "Otel Basri, 2006" }
export const STORY_PHOTOS = {};

// Müşteriye model/SKU kodu gösterme: "Casio W-96H-2AVDF Erkek Kol Saati" -> "Casio Erkek Kol Saati"
export const displayName = (name) =>
  (name || "")
    .split("|")
    .map((part) =>
      part
        .split(/\s+/)
        .filter((t) => !(/\d/.test(t) && /^[A-ZÇĞİÖŞÜ0-9][A-ZÇĞİÖŞÜ0-9.\-]*$/.test(t)))
        .join(" ")
        .trim()
    )
    .filter(Boolean)
    .join(" | ")
    .replace(/\s{2,}/g, " ")
    .trim();

// ─── Gerçek Shopify ürünlerinden seçimler ───────────────────────────────────
export const byId = (id) => PRODUCTS.find((p) => p.id === id);
const imgOf = (id, fallbackCategory) => {
  const p = byId(id) || PRODUCTS.find((x) => x.category === fallbackCategory);
  return p ? p.image : "";
};

export const HERO_PRODUCT =
  byId("danel-klein-erkek-kol-saati-siyah-kadran-celik-kordon") ||
  PRODUCTS.find((p) => p.category === "saat" && p.available);

export const IMAGES = {
  danielKlein: imgOf("valentino-orlandi-otomatik-erkek-kol-saati-celik-kordon-premium-seri", "saat"),
  catSaat: imgOf("danel-klein-erkek-kol-saati-siyah-kadran-celik-kordon", "saat"),
  catTaki: imgOf("danel-klein-cekik-erkek-bileklik", "taki"),
  catGozluk: imgOf("gunes-gozlugu", "gozluk"),
  catServis: imgOf("casio-mtp-v300d-1eudf", "saat"),
  price2000: imgOf("danel-klein-cekik-erkek-bileklik", "taki"),
  price3000: imgOf("casio-ltp-1215a-7adf", "saat"),
  price5000: imgOf("casio-mtp-v300d-1eudf", "saat"),
};

export const INSTAGRAM_POSTS = [
  "daniel-klein-tas-detayl-gold-renk-kadn-bileklik-saat",
  "valentino-orlandi-otomatik-erkek-kol-saati-celik-kordon-premium-seri",
  "danel-klein-erkek-kol-saati-siyah-kadran-celik-kordon",
  "casio-mtp-v300d-1eudf",
  "casio-ltp-1128g-7brdf",
  "casio-mtp-v001d-1e2vudf",
]
  .map((id) => byId(id))
  .filter(Boolean)
  .map((p) => ({ src: p.image, url: p.url, name: p.name }));

export const PRICE_COLLECTIONS = [
  { id: 2000, label: "2.000 TL Altı", desc: "Günlük şıklık için erişilebilir zarafet", image: IMAGES.price2000, testId: "price-collection-2000" },
  { id: 3000, label: "3.000 TL Altı", desc: "En sevilen Daniel Klein modelleri", image: IMAGES.price3000, testId: "price-collection-3000" },
  { id: 5000, label: "5.000 TL Altı", desc: "Premium tasarımlar, özel fiyatlar", image: IMAGES.price5000, testId: "price-collection-5000" },
];

// Vitrin görselleri — mağazadaki gerçek ürün fotoğraflarından seçildi
export const BRAND_IMAGES = {
  hero: imgOf("danel-klein-erkek-kol-saati-siyah-kadran-celik-kordon", "saat"),
  service: imgOf("valentino-orlandi-otomatik-erkek-kol-saati-celik-kordon-premium-seri", "saat"),
};

export const CATEGORIES = [
  { id: "saat", label: "Saatler" },
  { id: "taki", label: "Takı" },
  { id: "gozluk", label: "Gözlük" },
];
